<h1 class="strong" mat-dialog-title>
  {{ 'header.applicationFilter' | translate }}
</h1>
<div class="application-filter-dialog__content" mat-dialog-content>
  <app-dropdown [size]="100" [options]="[]" (changed)="handleChange()" label="header.settingsMenu.applicationFilter.group"></app-dropdown>
  <app-dropdown [size]="100" [options]="[]" (changed)="handleChange()" label="header.settingsMenu.applicationFilter.team"></app-dropdown>
  <app-dropdown [size]="100" [options]="[]" (changed)="handleChange()" label="header.settingsMenu.applicationFilter.partner"></app-dropdown>
</div>
<div mat-dialog-actions>
  <button class="btn btn-secondary" (click)="closeDialog()">
    {{ 'default.close' | translate }}
  </button>
  <button class="btn btn-primary" (click)="save()">
    {{ 'default.save' | translate }}
  </button>
</div>
